import { render, staticRenderFns } from "./FmTreeDemo.vue?vue&type=template&id=c63cb7a8&scoped=true&"
import script from "./FmTreeDemo.vue?vue&type=script&lang=js&"
export * from "./FmTreeDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63cb7a8",
  null
  
)

export default component.exports